module.exports = __webpack_public_path__ + "img/bb_g1_t_antenna-01.72b4a97b.svg";